import React from 'react';

import {
	Popper,
	Grow,
	Paper,
	MenuList,
	MenuItem,
	ClickAwayListener,
	Divider,
} from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/no-cycle
import { LOCATION, PROJECT } from '../../pages/PagePortfolio';

import IconUmbennen from '../../assets/icon-umbenennen.svg';
import IconEingeben from '../../assets/icon-eingeben.svg';
import IconUpload from '../../assets/icon-upload.svg';
import IconVerschieben from '../../assets/icon-verschieben.svg';
import IconSortTable from '../../assets/icon-spalten-editieren.svg';
import IconAddNewGroup from '../../assets/icon-standort-weltweit.svg';

const useStyles = makeStyles(() => ({
	optionsPopper: {
		'& ul': {
			padding: 0,

			'& > li': {
				padding: 18,
			},
		},
		'& img': {
			marginRight: 20,
		},
	},
}));

const OptionsMenu = ({
	openOptionsMenu,
	toggleOptionsMenu,
	anchorOptionsMenu,
	toggleRenameModal,
	toggleOpenLastgangModal,
	toggleAddInformation,
	visibilityBySelectedComponent,
	toggleCreateLocationModal,
}) => {
	const classes = useStyles();
	let ComponentMenu = null;

	switch (visibilityBySelectedComponent) {
		case PROJECT:
			ComponentMenu = (
				<MenuList>
					<MenuItem onClick={toggleRenameModal}>
						<img src={IconUmbennen} alt="IconUmbennen" />
						Umbenennen
					</MenuItem>
					<MenuItem disabled>
						<img src={IconVerschieben} alt="IconEingeben" />
						Verschieben
					</MenuItem>
					<MenuItem disabled>
						<img src={IconSortTable} alt="IconUpload" />
						Sortierung editieren
					</MenuItem>
					<MenuItem onClick={toggleCreateLocationModal}>
						<img src={IconAddNewGroup} alt="IconUpload" />
						Neue Niederlassung
					</MenuItem>
				</MenuList>
			);
			break;

		case LOCATION:
			ComponentMenu = (
				<MenuList>
					<MenuItem onClick={toggleRenameModal}>
						<img src={IconUmbennen} alt="IconUmbennen" />
						Umbenennen
					</MenuItem>
					<Divider />
					<MenuItem onClick={toggleAddInformation}>
						<img src={IconEingeben} alt="IconEingeben" />
						Informationen eingeben
					</MenuItem>
					<Divider />
					<MenuItem onClick={toggleOpenLastgangModal}>
						<img src={IconUpload} alt="IconUpload" />
						Lastgang hochladen
					</MenuItem>
				</MenuList>
			);
			break;

		default:
			break;
	}

	return (
		<Popper
			open={openOptionsMenu}
			anchorEl={anchorOptionsMenu.current}
			role={undefined}
			transition
			disablePortal
			className={classes.optionsPopper}
		>
			{({ TransitionProps, placement }) => (
				<Grow
					{...TransitionProps}
					style={{
						transformOrigin:
							placement === 'bottom' ? 'center top' : 'center bottom',
					}}
				>
					<Paper>
						<ClickAwayListener onClickAway={toggleOptionsMenu}>
							{ComponentMenu}
						</ClickAwayListener>
					</Paper>
				</Grow>
			)}
		</Popper>
	);
};

export default OptionsMenu;
